"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat !bg-[url(/img/mbf_rec.jpeg)] !bg-[url(https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/MBF-Rec-1.jpeg)]">
      {}
      <div className="absolute inset-0 bg-black/40 z-[1]" />

      {}
      <div ref={contentRef} className="relative z-10 max-w-4xl mx-auto px-6 md:px-8 text-center">
        <div className={`transition-all duration-700 ease-[var(--ease-smooth)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <h1 className="text-[48px] md:text-[64px] lg:text-[72px] leading-[1.1] font-bold tracking-[-0.3px] text-foreground mb-6">
            Wealth of Knowledge
          </h1>

          {}
          <p className="text-[18px] leading-[1.6] max-w-2xl mx-auto mb-10 !font-bold !text-[hsl(210,40%,98%)] md:text-[20px]">
            Expert tax analysis and HMRC compliance guidance, empowering your
            business with proactive financial strategies and modern cloud-based
            solutions.
          </p>

          {}
          <Link to="/team-and-contact#contact-us">
            <Button size="lg" className="rounded-[30px] px-8 py-4 text-[16px] font-semibold shadow-medium hover:shadow-strong hover:scale-[1.02] hover:brightness-110 focus-visible:ring-[3px] focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">Book your free consultation</Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-[14px] text-muted-foreground font-medium">
            Scroll
          </span>
          <svg className="w-6 h-6 text-muted-foreground" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>;
}